import { Box, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { ModuleKey } from '../registry';
import { MODULE_META } from '../registry/moduleMeta';

interface Props {
    module: ModuleKey;
}

/**
 * Shown in place of a module's deep-page board when the module is role-eligible for the current
 * user but the institution has not enabled it. Distinct from the plain redirect used for modules
 * the user's role can never see at all (see ModuleBoard).
 */
export default function ModuleUpsellCard({ module }: Props) {
    const meta = MODULE_META[module];
    return (
        <Box sx={{ p: 2 }}>
            <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', maxWidth: 480, mx: 'auto', mt: 4 }}>
                <LockOutlinedIcon color="disabled" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6" fontWeight={700} gutterBottom>{meta.label}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{meta.blurb}</Typography>
                <Typography variant="body2" color="text.secondary">
                    This module is not enabled for your institution — contact your administrator.
                </Typography>
            </Paper>
        </Box>
    );
}
